"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VouchersForm = void 0;
var _mui = require("@ori-ui/mui");
const VouchersForm = exports.VouchersForm = (0, _mui.styled)('form')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between'
});